export default "__VITE_ASSET__Bw3JcbCU__"